export const LAYERS = {
  TERRAIN: 0,
  FIRST_PERSON_ONLY: 1,
  MINI_MAP_ONLY: 2
};

export const WATER_SPEED = 0.1;
